module.exports = __webpack_public_path__ + "img/image335.6ef4f404.png";